import {
  Button,
  ButtonSize,
  ButtonVariant,
  Intent,
  Shape,
} from '@axieinfinity/matcha'
import { ArrowSquareOutIcon } from '@axieinfinity/matcha-icons'
import clsx from 'clsx'
import { useRouter } from 'next/router'

import bannerMFA from '~/public/images/banner-mfa.png'

import styles from './styles.module.scss'

export type TNotice2FAProps = {}

export const Notice2FA: React.FC<TNotice2FAProps> = () => {
  const router = useRouter()
  return (
    <div className={clsx(styles.noticeMFA, 'p-24 relative')}>
      <div className="flex flex-col gap-12 sm:w-2/3 relative z-10">
        <div className="text-h4">
          Two-factor authentication is now available
        </div>
        <div className="text-body-m text-text-color-subdued">
          Your account security is important to us. Enable two-factor
          authentication to help protect your Sky Mavis Account.
        </div>
      </div>

      <img
        className="absolute top-0 sm:right-24"
        src={bannerMFA}
        alt="banner-mfa"
      />

      <div className="flex flex-col sm:flex-row gap-12 mt-24">
        <Button
          text="Enable"
          size={ButtonSize.Small}
          shape={Shape.Default}
          intent={Intent.Primary}
          onClick={() => router.replace('/security')}
        />
        <Button
          size={ButtonSize.Small}
          shape={Shape.Default}
          intent={Intent.Primary}
          variant={ButtonVariant.Plain}
          text="Learn More"
          rightIcon={ArrowSquareOutIcon}
          onClick={async () =>
            window.open(
              'https://support.axieinfinity.com/hc/en-us/articles/4405346996251-How-to-Keep-Your-Account-Secure',
              '_blank',
            )
          }
        />
      </div>
    </div>
  )
}
